module.exports = __webpack_public_path__ + "static/media/img147.370c7421.jpg";